// Entry point for the build script in your package.json

// Disable Turbo until we need to use it (reverts forms to HTML submission)
// import "@hotwired/turbo-rails"
import { Turbo } from "@hotwired/turbo-rails"
Turbo.session.drive = false


import "./lib/jquery-loader"

import startSelect2 from  "select2"
startSelect2()

import Rails from "@rails/ujs"
Rails.start()

import "bootstrap"
import "@fortawesome/fontawesome-free/js/all"

import "./controllers"

import "./filterrific-copy/filterrific"

import { start as startDashboardMemberTransactions } from "./rewardcard/dashboard_member_transactions"
startDashboardMemberTransactions()

import { start as startJobLogs } from "./rewardcard/joblogs"
startJobLogs()

import { start as startRewardcard } from "./rewardcard/rewardcard"
startRewardcard()
